import { SmartLink } from "./SmartLink";

type SectionHeaderProps = {
  eyebrow?: string;
  title: string;
  action?: { label: string; href: string };
  centered?: boolean;
  level?: 1 | 2;
};

export function SectionHeader({ eyebrow, title, action, centered = false, level = 2 }: SectionHeaderProps) {
  const HeadingTag = level === 1 ? "h1" : "h2";

  return (
    <div className={`section-header ${centered ? "section-header-centered" : ""}`}>
      <div>
        {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        <HeadingTag>{title}</HeadingTag>
      </div>
      {action ? (
        <SmartLink href={action.href} className="text-link">
          {action.label}
        </SmartLink>
      ) : null}
    </div>
  );
}
